import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that can filter out a provided list of objects from another list. Requires
 * a matching attr to be provided to compare each object with. This is an unpure
 * pipe so use with care. Suitable for filtering out smaller lists etc.
 *
 * Usage:
 * value | objectsFilter:any[]:matchAttr:string
 *
 * Example:
 *
 * [{ id: 1 }, { id: 2 }] | objectsFilter:[{ id: 1 }]:'id'
 *
 * Outputs: [{ id: 2 }]
 */
@Pipe({
	name: 'objectsFilter',
	pure: false
})
export class ObjectsFilterPipe implements PipeTransform {
	transform(objectArray: any[], objectsToFilter: any[], matchAttr: string) {
		return objectArray.filter((item) => {
			return objectsToFilter.findIndex((itemFilter) => itemFilter[matchAttr] === item[matchAttr]) === -1;
		});
	}
}
